import { Routes } from '@angular/router';
import { SiteCommunicationsMassUploadComponent } from '../admin/upload-documents/category-upload-dialogs/site-specific/site-communications-mass-upload.component';
import { UserResolver } from '../admin/users/user-resolver';
import { TermsPopupComponent } from '../corporate/terms-popup.component';
import { PortalDisclaimerPopupComponent } from '../corporate/portal-disclaimer-popup.component';
import { GeneralDocumentsComponent } from '../general-documents/general-documents.component';
import { GeneralLevelComponent } from '../general-documents/general-level.component';
import { DashboardLevelLayoutComponent } from '../layout';
import { mailLinksRoutes } from '../mail-links/mail-links.routes';
import { UserSettingsComponent } from '../user';
import { UserEmulationComponent } from '../user-emulation';
import { AdminGuard } from './../admin/admin-guard';
import { GeneralDocumentsTabsComponent } from './../general-documents/general-documents-tabs.component';
import { GeneralDocumentsWithCategoriesComponent } from './../general-documents/general-documents-with-categories.component';
import { DashboardContainerComponent } from './dashboard-container.component';
import { UserSettingsAccessGuard } from './user-settings-access-guard';
import { UserPermissionGuard } from '../user-permissions/user-permission-guard';
import { navigationActivity } from '../activities/navigation-activity/navigation-activity-resolver';
import { permission } from '../user-permissions/route-permission';
import { generalDocumentsActivityHandler } from '../activities/navigation-activity/handlers/general/general-documents-activity-handler';
import { UserGeneralPreferencesComponent } from '../user/user-general-preferences-component';
import { routeData, routeParams } from '../shared/route-helpers';
import { EmailPreferencesComponent } from '../user/email-preferences/email-preferences.component';
import {InvestigatorEQueryDetailsDialogComponent} from '../investigator/e-queries/investigator-e-query/e-query-details/investigator-e-query-details-dialog.component';
import {InvestigatorGuard} from '../investigator/investigator-guard';
import {SponsorGuard} from '../sponsor/sponsor-guard';
import {SponsorEQueryDetailsDialogComponent} from '../sponsor/e-queries/e-query-details/sponsor-e-query-details-dialog.component';
import {CoordinatorEQueryDetailsDialogComponent} from '../admin/e-query/e-query-details/coordinator-e-query-details-dialog.component';

export const dashboardRoutes: Routes = [
    {
        path: '',
        component: DashboardLevelLayoutComponent,
        children: [
            {
                path: '',
                pathMatch: 'full',
                component: DashboardContainerComponent
            },

            ...mailLinksRoutes
        ]
    }
];

//TODO: temporary solution
export const globalDashboardRoutes: Routes = [
    {
        path: `user/:${routeParams.editedUserPk}`,
        resolve: {
            [routeData.user]: UserResolver
        },
        component: UserSettingsComponent,
        outlet: 'global-popup',
        children: [
            {
                path: '',
                redirectTo: 'general-settings',
                pathMatch: 'full'
            },
            {
                path: 'general-settings',
                component: UserGeneralPreferencesComponent,
            },
            {
                path: 'email-settings',
                canActivate: [UserSettingsAccessGuard],
                component: EmailPreferencesComponent,
            }
        ]
    },
    {
        path: 'emulate-user',
        canActivate: [AdminGuard, UserPermissionGuard],
        data: {
            ...permission('EmulateUser')
        },
        component: UserEmulationComponent,
        outlet: 'global-popup'
    },
    {
        path: 'site-communications-mass-upload',
        canActivate: [AdminGuard, UserPermissionGuard],
        data: {
            ...permission('UploadSiteCommunications')
        },
        component: SiteCommunicationsMassUploadComponent,
        outlet: 'global-popup'
    },
    {
        path: `general-documents/:${routeParams.categoryId}`,
        component: GeneralLevelComponent,
        outlet: 'global-popup',
        data: { ...generalDocumentsActivityHandler(routeParams.categoryId) },
        resolve: { ...navigationActivity },
        children: [
            {
                path: '',
                component: GeneralDocumentsComponent
            },
            {
                path: '',
                component: GeneralDocumentsTabsComponent,
                children: [
                    {
                        data: { ...generalDocumentsActivityHandler(routeParams.childCategoryId) },
                        resolve: { ...navigationActivity },
                        path: `:${routeParams.childCategoryId}`,
                        component: GeneralDocumentsWithCategoriesComponent
                    }
                ]
            },
        ]
    },
    {
        path: `investigator-e-query-details/:${routeParams.eQueryId}`,
        component: InvestigatorEQueryDetailsDialogComponent,
        outlet: 'global-popup',
        canActivate: [InvestigatorGuard]
    },
    {
        path: `sponsor-e-query-details/:${routeParams.eQueryId}`,
        component: SponsorEQueryDetailsDialogComponent,
        outlet: 'global-popup',
        canActivate: [SponsorGuard]
    },
    {
        path: `coordinator-e-query-details/:${routeParams.eQueryId}`,
        component: CoordinatorEQueryDetailsDialogComponent,
        outlet: 'global-popup',
        canActivate: [AdminGuard]
    },
    {
        path: 'terms-and-conditions',
        component: TermsPopupComponent,
        outlet: 'global-popup'
    },
    {
        path: 'disclaimer',
        component: PortalDisclaimerPopupComponent,
        outlet: 'global-popup'
    }
];
